export const Actions = {
    SET_PROFILE: 'SET_PROFILE',
    UPDATE_FAVORITES: 'UPDATE_FAVORITES',
    UPDATE_PERSONA: 'UPDATE_PERSONA',
    ADD_NOTIFICATION: 'ADD_NOTIFICATION',
    REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
    ADD_DASHBOARDS: 'ADD_DASHBOARDS',
    ADD_WHATS_NEW: 'ADD_WHATS_NEW'
};